var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "Add Property"
    ),
    React.createElement("path", { d: "M8.5 8.5v-2a.5.5 0 0 0-1 0v2h-2a.5.5 0 0 0 0 1h2v2a.5.5 0 1 0 1 0v-2h2a.5.5 0 1 0 0-1h-2zM.315 6.894L7.159.46c.314-.296.458-.372.63-.422a.907.907 0 0 1 .517.001c.172.051.315.128.628.425l6.784 6.434a1 1 0 0 1-.688 1.726h-1.304v5.718c0 .446-.047.607-.134.77a.909.909 0 0 1-.378.378c-.163.087-.325.134-.77.134H3.57c-.446 0-.608-.047-.77-.134a.909.909 0 0 1-.379-.378c-.087-.163-.133-.324-.133-.77V8.623H1a1 1 0 0 1-.685-1.729z", fill: "#494444", fillRule: "evenodd" })
  );
});